/*
  Violet, sitewide: the page bridge (window.SubtlVioletPage).

  The flyout (assets/ssd-violet.js) never touches the page directly; it asks
  a bridge. The SSD 10A landing page has its own (window.SubtlSSD10A, in
  ssd-landing-10a.js). Every other page gets this one, built from the JSON
  that snippets/violet-state.liquid renders.

  What it decides:
  - the match set for this page: the Deluxe's pods on the Deluxe pages, the
    Starter Stak's on its page, and elsewhere the current product plus the
    best-selling shade products (five by default), all of them full pods;
    "Match more" opens the rest
  - every product's shade from the concealer code: the theme's maps for BB,
    bronzer, lip and cheek and eyeshadow; the balm from the bronzer; blush
    and lip glaze from the picks Violet made on the selfie; Brow BFF from
    her brow pick (read from the brows, and left out when there is none);
    single-shade products as themselves
  - the sitewide record (localStorage 'subtl:shade') and the on-page
    selection, through the same applier the chat path has always used
  - add to bag: the Stak variant with its pod line properties, or one line
    per matched product
*/
(function () {
  'use strict';
  if (window.SubtlSSD10A) return;          // the landing page brings its own bridge
  var el = document.querySelector('[data-violet-state]');
  if (!el) return;
  var D;
  try { D = JSON.parse(el.textContent); } catch (e) { return; }

  // ── Catalog ──────────────────────────────────────────────────────────────
  var products = {}, order = [], byRole = {};
  (D.products || []).forEach(function (p) {
    if (!p || !p.handle || products[p.handle]) return;
    products[p.handle] = p; order.push(p.handle);
    if (!byRole[p.role]) byRole[p.role] = p;
  });
  var staks = D.staks || {};
  var mode = D.mode || 'products';
  var stak = mode === 'deluxe' ? staks.deluxe : mode === 'starter' ? staks.starter : null;
  var S = D.strings || {};

  function pipeMap(str, n) {
    var out = {};
    String(str || '').split('|').forEach(function (row) {
      var parts = row.split(':'); if (parts.length < 2) return;
      out[parts[0].trim()] = n === 1 ? parts[1].trim() : parts.slice(1).map(function (s) { return s.trim(); });
    });
    return out;
  }
  var shades = {};
  Object.keys(pipeMap(D.shadeTable)).forEach(function (code) {
    var v = pipeMap(D.shadeTable)[code]; shades[code] = { hex: v[0], tone: v[1], tier: v[2] };
  });
  var bbMap = pipeMap(D.bbMap, 1), bronzerMap = pipeMap(D.bronzerMap, 1), balmMap = pipeMap(D.balmMap, 1);
  var undertone = {};
  Object.keys(pipeMap(D.undertoneMap)).forEach(function (l) { var v = pipeMap(D.undertoneMap)[l]; undertone[l] = { lipcheek: v[0], eyeshadow: v[1] }; });

  var picks = { blush: null, lip_glaze: null, brow: null };
  var state = { matched: null, matchedBy: null, matchId: null, more: false };

  // Mirrors snippets/undertone-resolve.liquid: the trailing letter, N when unknown.
  function letterOf(code) { var l = String(code || '').slice(-1).toUpperCase(); return undertone[l] ? l : 'N'; }
  function firstShade(role) { var p = byRole[role]; return p && p.variants && p.variants[0] ? p.variants[0].t : ''; }

  function pairingFor(code) {
    var u = undertone[letterOf(code)] || {};
    var bronzer = bronzerMap[code] || '';
    return {
      concealer: code,
      bb: bbMap[code] || '',
      bronzer: bronzer,
      balm: bronzer ? (balmMap[bronzer] || '') : '',
      lipcheek: u.lipcheek || '',
      eyeshadow: u.eyeshadow || '',
      // Violet picks these from the selfie; an older match without picks
      // falls back to the letter (cool → the mauve; else the peach) and the nude.
      blush: picks.blush || (letterOf(code) === 'C' ? 'Blossom Bound' : 'Daytrip at Dawn'),
      glaze: picks.lip_glaze || 'Undone',
      // No fallback: brow shade comes from the brows, not the concealer.
      brow: picks.brow || '',
      highlighter: firstShade('highlighter'),
      creamhighlighter: firstShade('creamhighlighter'),
      shine: firstShade('shine'),
    };
  }

  function variantOf(p, shade) {
    var vs = (p && p.variants) || [];
    return vs.find(function (v) { return v.t === shade; }) || (vs.length === 1 ? vs[0] : null);
  }
  function item(p, pr) {
    var shade = pr[p.role] || '', v = variantOf(p, shade), t = v ? v.t : shade;
    return { role: p.role, handle: p.handle, name: p.title, url: p.url, shade: t, pan: (p.pan || {})[t] || (v && v.img) || p.image || '',
      price: v ? v.p : p.price, variantId: v ? v.id : null, available: !!(v && v.a) };
  }

  // The match set for this page. On a Stak page: its pods, concealer first.
  // Elsewhere: the current product if it is a shade product, then the
  // best-sellers until five in all; "all" opens the whole list.
  function set(code, opts) {
    if (!code) return [];
    var pr = pairingFor(code), all = !!(opts && opts.all), rows = [];
    if (stak) {
      (stak.pods || []).forEach(function (role) { var p = byRole[role]; if (p) rows.push(item(p, pr)); });
      rows.sort(function (a, b) { return (a.role === 'concealer' ? 0 : 1) - (b.role === 'concealer' ? 0 : 1); });
      return rows;
    }
    var current = D.current && products[D.current] ? D.current : null;
    var limit = Number(D.topCount || 4) + 1;
    // Brow BFF only once Violet has read the brows.
    function usable(h) { return products[h].role !== 'brow' || !!pr.brow; }
    if (current && usable(current)) rows.push(item(products[current], pr));
    order.forEach(function (h) {
      if (h === current || !usable(h)) return;
      if (!all && rows.length >= limit) return;
      rows.push(item(products[h], pr));
    });
    return rows;
  }
  function canMore(code) { return !stak && set(code, { all: true }).length > set(code).length; }
  function money(cents) { var n = Number(cents || 0) / 100; return '$' + (n % 1 ? n.toFixed(2) : String(n)); }
  function priceFor(code, opts) {
    if (stak) return money(stak.price);
    var sum = 0;
    set(code, opts).forEach(function (r) { if (r.available) sum += Number(r.price || 0); });
    return money(sum);
  }
  function heading(opts) {
    if (mode === 'deluxe') return S.headingDeluxe || 'Your shades, all five, matched together';
    if (mode === 'starter') return S.headingStarter || 'Your Starter Stak, matched';
    return opts && opts.all ? (S.headingAll || 'Everything, matched to you') : (S.headingTop || 'Your top picks, matched');
  }

  // The Stak variant for a code (BB + concealer on the Deluxe, concealer on
  // the Starter), else the concealer product's own variant: what the flyout
  // checks for stock before it presents a read.
  function variantFor(code) {
    if (!code) return null;
    if (stak && stak.variants) {
      var two = (stak.options || []).length === 2, bb = pairingFor(code).bb, exact = null, same = null;
      stak.variants.forEach(function (v) {
        if ((two ? v.o2 : v.o1) !== code) return;
        if (!same || (!same.a && v.a)) same = v;
        if (two && bb && v.o1 === bb && (!exact || v.a)) exact = v;
      });
      return exact || same || null;
    }
    var p = byRole.concealer, v = p ? variantOf(p, code) : null;
    return v ? { id: v.id, a: v.a } : null;
  }

  function panFor(role, shade) {
    var p = byRole[role]; if (!p) return '';
    var v = variantOf(p, shade);
    return (p.pan || {})[shade] || (v && v.img) || '';
  }

  // Everything this match resolves to, for the sitewide record: every shade
  // product plus both Staks, so any product page or the compare card
  // preselects the right shade.
  function siteRecord(code) {
    var recs = set(code, { all: true }).map(function (r) { return { handle: r.handle, shade: r.shade }; });
    var pr = pairingFor(code);
    ['deluxe', 'starter'].forEach(function (k) {
      var s = staks[k]; if (!s || !s.handle) return;
      if ((s.options || []).length === 2 && pr.bb) recs.push({ handle: s.handle, shade: pr.bb });
      recs.push({ handle: s.handle, shade: code });
    });
    return recs;
  }

  function setPicks(p) {
    if (!p || typeof p !== 'object') return;
    if (typeof p.blush === 'string' && p.blush) picks.blush = p.blush;
    if (typeof p.lip_glaze === 'string' && p.lip_glaze) picks.lip_glaze = p.lip_glaze;
    if (typeof p.brow === 'string' && p.brow) picks.brow = p.brow;
  }

  function applyMatch(code, meta) {
    if (!shades[code]) return false;
    state.matched = code;
    state.matchedBy = (meta && meta.by) || 'violet';
    state.matchId = (meta && meta.matchId) || null;
    if (meta && meta.picks) setPicks(meta.picks);
    // Select it on this page now, through the applier the chat path uses
    // (assets/violet-shade-match.js). It finds the current PDP's picker,
    // product cards on a grid, or nothing, and says nothing when nothing.
    try { if (window.SubtlShadeApply && typeof window.SubtlShadeApply.apply === 'function') window.SubtlShadeApply.apply(siteRecord(code)); } catch (e) { /* the record still carries it */ }
    document.dispatchEvent(new CustomEvent('subtl:violet:matched', { detail: { code: code, matchId: state.matchId, mode: mode, picks: picks } }));
    return true;
  }

  function refreshCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-js-cart-count], [data-ssd10-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    }).catch(function () { /* decoration */ });
  }

  // Add to bag. A Stak: its variant with the pod line properties the PDP
  // writes. Products: one line per matched, buyable product, the shade on
  // each. Returns a promise so the flyout can speak once it is in.
  function addToBag(opts) {
    var code = state.matched; if (!code) return Promise.resolve(false);
    var pr = pairingFor(code), items = [];
    var base = { _shade_match: code, _shade_matched_by: state.matchedBy || 'violet' };
    if (state.matchId) base._violet_match_id = state.matchId;
    if (stak) {
      var v = variantFor(code); if (!v || !v.a) return Promise.resolve(false);
      var p = Object.assign({}, base), pods = stak.pods || [];
      if ((stak.options || []).length === 2 && pr.bb) p._bb_powder = pr.bb;
      if (pods.indexOf('bronzer') !== -1 && pr.bronzer) p._powder_bronzer = pr.bronzer;
      if (pods.indexOf('lipcheek') !== -1 && pr.lipcheek) p._lip_and_cheek = pr.lipcheek;
      if (pods.indexOf('eyeshadow') !== -1 && pr.eyeshadow) p._eyeshadow_duo = pr.eyeshadow;
      items.push({ id: v.id, quantity: 1, properties: p });
    } else {
      set(code, { all: !!(opts && opts.all) }).forEach(function (r) {
        if (r.variantId && r.available) items.push({ id: r.variantId, quantity: 1, properties: Object.assign({}, base, { _shade_match: r.shade }) });
      });
    }
    if (!items.length) return Promise.resolve(false);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json().catch(function () { return null; }); })
      .then(function () {
        refreshCart();
        var sc = window.Rebuy && window.Rebuy.SmartCart;
        if (sc && sc.status === 'ready' && typeof sc.show === 'function') sc.show();
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        document.dispatchEvent(new CustomEvent('subtl:ssd10:added', { detail: { code: code, items: items.length } }));
        return true;
      });
  }

  function openKustomer() {
    try {
      if (window.Kustomer && typeof window.Kustomer.open === 'function') {
        window.Kustomer.open();
        if (typeof window.Kustomer.createConversation === 'function') window.Kustomer.createConversation({}, function () {});
      }
    } catch (e) { /* ignore */ }
  }

  var handles = { concealer: byRole.concealer && byRole.concealer.handle, bb: byRole.bb && byRole.bb.handle, bronzer: byRole.bronzer && byRole.bronzer.handle,
    lipcheek: byRole.lipcheek && byRole.lipcheek.handle, eyeshadow: byRole.eyeshadow && byRole.eyeshadow.handle,
    ssd: staks.deluxe && staks.deluxe.handle, starter: staks.starter && staks.starter.handle };

  window.SubtlVioletPage = {
    mode: mode,
    shades: shades,
    handles: handles,
    price: stak ? money(stak.price) : '',
    stakName: stak ? stak.title : '',
    pairingFor: pairingFor,
    variantFor: variantFor,
    panFor: panFor,
    set: set,
    canMore: canMore,
    priceFor: priceFor,
    heading: heading,
    siteRecord: siteRecord,
    setPicks: setPicks,
    applyMatch: applyMatch,
    suggest: function () {},
    addToBag: addToBag,
    refreshCart: refreshCart,
    openKustomer: openKustomer,
  };
})();
